import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { ConfigService } from '@sp-client/app/services/config.service';

@Injectable({ providedIn: 'root' })
export class DesktopOnlyGuard implements CanMatch {
	constructor(private configService: ConfigService) {}

	canMatch(route: Route, segments: UrlSegment[]): boolean {
		return !this.configService.isMobileSignal();
	}
}
